import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { poppinsCustomTheme } from "../../Styles/GlobalStyles/PoppinsTheme";
import { ThemeProvider } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Draggable from "react-draggable";
import Slide from "@mui/material/Slide";
import { GreenButton, GreyOutlinedButton } from "../Button/CustomButton";
import { Typography } from "../../Styles/GlobalStyles/Variables";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function DialogBox({ openDialog, setOpenDialog }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  function PaperComponent(props) {
    return (
      <Draggable
        handle="#draggable-dialog-title"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} />
      </Draggable>
    );
  }
  return (
    <ThemeProvider theme={poppinsCustomTheme}>
      <Dialog
       maxWidth="md"
        fullWidth={true}
        fullScreen={fullScreen}
        open={openDialog.open}
        TransitionComponent={Transition}
        keepMounted
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        PaperProps={{
          style: { borderRadius: 20, padding: 10 },
        }}
      >
        <DialogTitle
          sx={{ fontSize: "20px", fontWeight: 700 }}
          id="responsive-dialog-title"
        >
          {openDialog.Title}
        </DialogTitle>
        <DialogContent
          sx={{ padding: "0px 10px", textTransform: "capitalize" }}
        >
          {/*  <DialogContentText>
            Let Google help apps determine location. This means sending anonymous
            location data to Google, even when no apps are running.
          </DialogContentText> */}
          {openDialog.Content}
        </DialogContent>
        <DialogActions sx={{ textTransform: "capitalize", p: 3 }}>
          <GreyOutlinedButton
            sx={{ fontFamily: Typography.secondaryFont }}
            autoFocus
            onClick={() => {
              setOpenDialog({ ...openDialog, open: false });
            }}
          >
            Cancel
          </GreyOutlinedButton>
          <GreenButton
            sx={{ padding: "5px 20px", fontFamily: Typography.secondaryFont }}
            onClick={() => {
              setOpenDialog({ ...openDialog, open: false });
            }}
            autoFocus
          >
            {openDialog.actionButton}
          </GreenButton>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
}
